/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import { FormHelperText, Grid, TextField } from '@material-ui/core'

const styles = theme => ({
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    questionWrapper: {
        marginTop: '0px!important'
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '4px!important'
        }
    },
    textField: {
        '& fieldset': {
            border: theme.input ? theme.input.border + '!important' : null
        }
    },
    outlinedTextField: {
        '& input': {
            background: '#fff'
        },
    }
})

class TextQuestion extends Component {
    state = {}

    handleChange = event => {
        this.props.onValueChanged(this.props.question.id, event.target.value)
    }

    render() {
        const { classes, value, question, theme } = this.props

        const inputValue = value ? value : ''
        return (
            <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)} className={classes.questionWrapper}>
                <TextField
                    required
                    label={question.title}
                    name={question.name}
                    fullWidth
                    variant={theme.inputVariant}
                    autoFocus={question.autoFocus}
                    onChange={this.handleChange}
                    error={question.valid === false}
                    value={inputValue}
                    className={
                        classes.textField +
                        ' inputText ' +
                        (theme.inputVariant === 'outlined' ? classes.outlinedTextField + ' outlinedInputText' : '')
                    }
                />
                {question.description && <FormHelperText>{question.description}</FormHelperText>}
                {question.valid === false && (
                    <Grid item xs={12} style={{ paddingTop: 0 }}>
                        <FormHelperText className={classes.errorText}>{question.errorMessage}</FormHelperText>
                    </Grid>
                )}
            </Grid>
        )
    }
}

export default withStyles(styles)(TextQuestion)
